import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import EditIcon from "@/assets/images/icons2/icon--edit.svg?component";

import { ActiveGoal } from "./ActiveGoal";

export function NonEmptyGoalsDisplay(props) {
  const { canEdit, currentGoalsAndObjectives, onAddGoalClick, shouldShowAddGoal } = props;

  if (!currentGoalsAndObjectives) {
    return <></>;
  }

  return (
    <div className="CareGoalsCard--non-empty-goals-display">
      {currentGoalsAndObjectives.map((goal) => {
        return (
          <ActiveGoal
            canEdit={canEdit}
            goal={goal}
            key={`ActiveGoal-${goal.goal_id}`}
            onAddObjectiveClick={props.onAddObjectiveClick}
            onCompleteObjectiveClick={props.onCompleteObjectiveClick}
            onEditObjectiveClick={props.onEditObjectiveClick}
            onRemoveObjectiveClick={props.onRemoveObjectiveClick}
          />
        );
      })}

      {shouldShowAddGoal && (
        <div className="tw:flex tw:items-center tw:gap-ch">
          <Button2 icon={<EditIcon />} onPress={() => onAddGoalClick()} size="xs" variant="link">
            Add Goal
          </Button2>

          <small className="body-xs">(Max 3)</small>
        </div>
      )}
    </div>
  );
}
